/**
 * Route Configuration
 *
 * Common route configuration helpers and utilities
 */

import { APP_CONFIG } from "../../configs/config";
import { DEFAULT_PRODUCTS } from "../../data/product";

/**
 * Gets the URL for a product by title
 * @param {string} productTitle - The product title to search for
 * @returns {string} The product URL or "#" if not found
 */
export const getProductUrl = (productTitle) => {
  const product = DEFAULT_PRODUCTS.find((p) => p.title === productTitle);
  return product ? product.ctaUrl : "#";
};

/**
 * Gets the suggestions for the home page
 * @returns {Array} Array of suggestion objects with key and url
 */
export const getHomeSuggestions = () => [
  { key: "searchTrademark", url: getProductUrl("TadReamk Eye") },
  { key: "searchPatent", url: getProductUrl("TadReamk Patent") },
  { key: "generateTrademark", url: getProductUrl("TadReamk Create") },
  { key: "tradeTrademark", url: getProductUrl("Trademark Trading") },
  { key: "monitorProduct", url: getProductUrl("TadReamk Surveillance") },
  { key: "manageBusinessCards", url: APP_CONFIG.BUSINESS_CARD_SERVICE_URL },
];

/**
 * Gets common props for components
 * @param {Object} config - Configuration object
 * @returns {Object} Props object with logoUrl
 */
export const getCommonProps = (config = {}) => ({
  logoUrl: APP_CONFIG.LOGO_URL,
  ...config,
});
